import HistWeather from "./HistWeather";

export default HistWeather;